import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren } from 'react';

import { ApplySMSButtonProps } from '../interface';

export default observer((props: PropsWithChildren<ApplySMSButtonProps>) => {
  const { isLoading, isDisabled, children, className } = props;

  return (
    <button
      data-button="apply"
      className={classes(['button _primary _block _med', className])}
      disabled={isDisabled || isLoading}
      type="submit"
    >
      {isLoading && <span className="spinner _white" />}

      {!isLoading && children}
    </button>
  );
});
